import axios from "@/lib/request";

// 获取备注列表
export const getNoteList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/note/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 添加备注
export const addNote = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/note/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取用户信息
export const getUserInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/user/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除备注
export const deleteNote = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/note/delete",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 编辑备注
export const updateNote = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/note/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};